// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "business_profile".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { businessVerticalValues, commitmentLevelValues, marketPositionValues, retentionModelValues } from '@borradh-workspace/labels';
/** Response atom for the "business_profile" table (1:1 with a DB row, on the wire). */
export const businessProfileAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    vertical: z.enum(businessVerticalValues),
    retentionModel: z.enum(retentionModelValues),
    commitmentLevel: z.enum(commitmentLevelValues),
    marketPosition: z.enum(marketPositionValues),
    axesConfidence: z.number().nullable(),
    axesReasoning: z.string().nullable(),
    classifierAxes: z.unknown().nullable(),
    overriddenAxes: z.unknown().nullable(),
    disagreement: z.unknown().nullable(),
    rankedServices: z.unknown(),
    inputHash: z.string(),
    classifiedAt: z.string().datetime(),
    classifierVersion: z.string(),
    verticalMetadata: z.unknown(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=businessProfile.js.map